/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AdminDto } from '../../models/admin-dto';

export interface AdminControllerFindById$Params {
  id: string;
}

export function adminControllerFindById(http: HttpClient, rootUrl: string, params: AdminControllerFindById$Params, context?: HttpContext): Observable<StrictHttpResponse<AdminDto>> {
  const rb = new RequestBuilder(rootUrl, adminControllerFindById.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AdminDto>;
    })
  );
}

adminControllerFindById.PATH = '/api/admin/{id}';
